// extracted by mini-css-extract-plugin
export default {"wrap":"Ro-z","logoContainer":"So-z","brandImg":"To-z","logoImg":"Uo-z","logoButton":"Vo-z"};